import React from "react";
import LoadingState from "./LoadingState";

type RefreshButtonProps = {
  busy: boolean;
  onClick: () => void;
  disabled?: boolean;
  idleText?: string;
  busyText?: string;
  className?: string;
  busyClassName?: string;
};

export default function RefreshButton(props: RefreshButtonProps): React.ReactElement {
  const {
    busy,
    onClick,
    disabled = false,
    idleText = "Refresh",
    busyText = "Refreshing...",
    className = "px-3 py-2 text-sm rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 disabled:opacity-50",
    busyClassName = "inline-flex items-center gap-2 text-xs text-gray-600 dark:text-slate-400",
  } = props;

  if (busy) {
    return <LoadingState label={busyText} className={busyClassName} />;
  }

  return (
    <button
      type="button"
      className={className}
      disabled={disabled}
      onClick={() => onClick()}
    >
      {idleText}
    </button>
  );
}

